import { FullPageCard, GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";

export function ContactNotFound() {
  const { hasPagePermission } = useUser();

  // If the user doesn't have permission to view contacts, we don't want to
  // give them information about whether a contact exists or not.
  if (!hasPagePermission(PAGE_PERMISSION_KEYS.contactsDetail)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <FullPageCard
      backButtonLink="/contacts"
      backButtonTitle="Back to contacts"
      title="Contact not found"
    >
      <p className="text-muted-foreground">
        {`Oops! The contact you're looking for doesn't exist.`}
      </p>
    </FullPageCard>
  );
}
